import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SocialMediaSharingComponent } from './components/social-media-sharing/social-media-sharing.component';
import { FiltrationResultMessageComponent } from './components/filtration-result-message/filtration-result-message.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductRatingComponent } from './components/product-rating/product-rating.component';
import { SafeHtmlPipe } from './Pipes/SafeHtmlPipe';


@NgModule({
  imports: [CommonModule, FormsModule, NgbModule],
  declarations: [
    SocialMediaSharingComponent,
    FiltrationResultMessageComponent,
    ProductRatingComponent,
    SafeHtmlPipe
  ],
  providers: [],
  exports: [
    CommonModule,
    FormsModule,
    SocialMediaSharingComponent,
    FiltrationResultMessageComponent,
    ProductRatingComponent,
    SafeHtmlPipe
  ]
})
export class SharedModule { }
